import { useState } from "react";
import { Link } from "react-router-dom";
import { User, List, X } from "@phosphor-icons/react";
import { NAV } from "./siteData";
import { useAuth } from "../../context/AuthContext";

export const SiteNav = ({ active }) => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const loginTo = user ? "/dashboard" : "/login";
  const loginLabel = user ? "Dashboard" : "Login";

  return (
    <header className="fixed top-3 inset-x-0 z-40 px-3 md:px-6" data-testid="site-nav">
      <div className="max-w-7xl mx-auto flex items-center gap-3">
        <nav className="flex-1 bg-white/95 backdrop-blur-xl rounded-full shadow-sm border border-zinc-200 px-3 py-2 flex items-center">
          <div className="hidden lg:flex items-center gap-1 w-full">
            {NAV.map((n) => (
              <a key={n.id} href={`#${n.id}`} data-testid={`site-nav-${n.id}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  active === n.id ? "bg-[#0B3A8C] text-white" : "text-zinc-800 hover:bg-blue-50"}`}>
                {n.label}
              </a>
            ))}
          </div>
          <div className="lg:hidden flex items-center justify-between w-full">
            <span className="font-display font-bold text-[#0B3A8C] pl-2">Our Schools</span>
            <button data-testid="site-nav-menu-toggle" onClick={() => setOpen(!open)} className="p-2">
              {open ? <X size={22} /> : <List size={22} />}
            </button>
          </div>
        </nav>
        <Link to={loginTo} data-testid="site-login-button"
          className="shrink-0 inline-flex items-center gap-2 bg-[#0B3A8C] hover:bg-[#082C6B] text-white rounded-full px-5 py-3 text-sm font-semibold shadow-sm transition-colors">
          <User size={18} weight="fill" /> {loginLabel}
        </Link>
      </div>
      {open && (
        <div className="lg:hidden max-w-7xl mx-auto mt-2 bg-white rounded-2xl border border-zinc-200 shadow-sm p-2">
          {NAV.map((n) => (
            <a key={n.id} href={`#${n.id}`} onClick={() => setOpen(false)}
              data-testid={`site-mnav-${n.id}`}
              className="block px-4 py-2.5 rounded-lg text-sm hover:bg-blue-50">{n.label}</a>
          ))}
        </div>
      )}
    </header>
  );
};
